import { render, staticRenderFns } from "./UserAdd.vue?vue&type=template&id=05984a06&scoped=true"
import script from "./UserAdd.vue?vue&type=script&lang=js"
export * from "./UserAdd.vue?vue&type=script&lang=js"
import style0 from "./UserAdd.vue?vue&type=style&index=0&id=05984a06&prod&scoped=true&lang=css"
import style1 from "./UserAdd.vue?vue&type=style&index=1&id=05984a06&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05984a06",
  null
  
)

export default component.exports